import React, { useState } from 'react';
import { FiCalendar, FiImage, FiPhone, FiMenu, FiX } from 'react-icons/fi';
import { Link, useNavigate } from 'react-router-dom';

export default function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <>
            <div className="top-bar"></div>
            <header className="site-header d-flex align-items-center justify-content-between">
                <div className="brand d-flex align-items-center">
                    <div className="logo-container" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                        <div className="logo-bg-circle"></div>
                        <img src="/img/PureGoldNadaYogaBest.png" alt="Nada logo" className="logo-img" />
                    </div>
                    <div className="brand-text">
                        <img src="/img/MainTitleGroup1.png" alt="Nada Yoga Title" className="brand-title-img" />
                    </div>
                </div>

                <div className="header-actions d-flex align-items-center position-relative mb-1">


                    <div className="menu-wrapper" style={{ position: 'relative' }}>
                        <div onClick={() => setMenuOpen(!menuOpen)} style={{ cursor: 'pointer', zIndex: 1001, position: 'relative' }}>
                            {menuOpen ? <FiX size={32} color="#fff" /> : <FiMenu size={32} />}
                        </div>

                        {menuOpen && (
                            <div className="mobile-menu-dropdown">
                                <Link to="/" className="menu-link" onClick={() => setMenuOpen(false)}>Home</Link>
                                <Link to="/contact" className="menu-link" onClick={() => setMenuOpen(false)}>Contact Us</Link>
                                <a href="tel:9741527464" className="menu-link" style={{ color: 'inherit', display: 'flex', textDecoration: 'underline' }}>
                                    <h6>+91 9741527464</h6>
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </header>
        </>
    );
}